import { Status } from "../../DataFrame";
import { ResponseResult } from "../FieldChangeResult";
import { IPicture } from "../Pictures/IPicture";

export interface IUser {
    get Guid(): string;
    get CloudGuid(): string;
    get Name(): string;
    get Surname(): string;
    get Phone(): string;
    get AccessLevel(): AccessLevel;
    get Email(): string;
    get IsAccountOnline(): boolean;
    get IsActive(): boolean;
    get IsBanned(): boolean;
    get NotificationChannels(): string[];
    get Gender(): Gender;
    get Localization(): Localization;
    get SoftwareVersion(): string;
    GetUserProfilePictureAsync(): Promise<IPicture | ResponseResult<Status>>;
    SetUserProfilePictureAsync(base64PictureString: string): Promise<ResponseResult<Status>>;
}

export enum AccessLevel
{
    Any = 0,
    Guest = 10,
    Standard = 20,
    Admin = 30,
    Installator = 40,
    Support = 50
}

export enum Gender
{
    Unknown = 0,
    Men = 1,
    Woman = 2,
    Other = 3
}

export enum Localization
{
    En_Us = 0,
    Pl_Pl = 1,
}